import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Input, OnInit, QueryList, ViewChildren, WritableSignal, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { AcquedottiInputSelectComponent } from 'src/app/modules/acquedotti/components/acquedotti-input-select/acquedotti-input-select.component';
import { IstatComuniInputSelectComponent } from 'src/app/modules/istat-comuni/components/istat-comuni-input-select/istat-comuni-input-select.component';
import { IstatRegioniInputSelectComponent } from 'src/app/modules/istat-regioni/components/istat-regioni-input-select/istat-regioni-input-select.component';
import { IstatRegioniService } from 'src/app/modules/istat-regioni/istat-regioni.service';
import { PuntiCampionamentoTipologieInputSelectComponent } from 'src/app/modules/punti-campionamento-tipologie/components/punti-campionamento-tipologie-input-select/punti-campionamento-tipologie-input-select.component';
import { WaterSupplyZoneInputSelectComponent } from 'src/app/modules/water-supply-zone/components/wsz-input-select/wsz-input-select.component';
import { FiltersGroupComponent } from 'src/app/shared/components/filters/filters-group/filters-group.component';
import { FiltersPanelComponent } from 'src/app/shared/components/filters/filters-panel/filters-panel.component';
import { InputNumberComponent } from 'src/app/shared/components/inputs/input-number/input-number.component';
import { InputSelectComponent } from 'src/app/shared/components/inputs/input-select/input-select.component';
import { InputTextComponent } from 'src/app/shared/components/inputs/input-text/input-text.component';
import { InputSelectStringComponent } from "../../input-select-string/input-select-string.component";
import { WaterSupplyZoneService } from 'src/app/modules/water-supply-zone/water-supply-zone.service';
import { AcquedottiService } from 'src/app/modules/acquedotti/acquedotti.service';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import { InputToggleComponent } from "../../../../../shared/components/inputs/input-toggle/input-toggle.component";
@Component({
  selector: 'app-filters-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatIconModule,
    MatTooltipModule,
    MatDividerModule,
    FiltersPanelComponent,
    FiltersGroupComponent,
    InputTextComponent,
    InputNumberComponent,
    MatCheckboxModule,
    IstatRegioniInputSelectComponent,
    IstatComuniInputSelectComponent,
    PuntiCampionamentoTipologieInputSelectComponent,
    WaterSupplyZoneInputSelectComponent,
    AcquedottiInputSelectComponent,
    InputSelectStringComponent,
    InputToggleComponent
],
  templateUrl: './filters-form.component.html',
  styleUrl: './filters-form.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FiltersFormComponent implements OnInit {
  @Input() form!: FormGroup;
  @Input() filtroDataValidita: boolean = true;
  integerPattern = "^-?[0-9]+$";
  regioni = this.regioniService.query.list;
  istatRegione: WritableSignal<number | undefined> = signal(undefined);
  wsz = this.wszService.query.list;
  acquedotti = this.acquedottiService.query.list;
  wszAll:string[]=[]
  acquedottiAll:string[]=[]
  checked: Array<{ checked: boolean; value: string }> = [];

  items = ['validi', 'scaduti', 'non_ancora_validi'];

  @ViewChildren('checkBox') checkBox!: QueryList<any>; // Correct usage of ViewChildren

  callBackFunctionWsz = (list:any, currentValue:string) => {
    const filteredList = this.wszService.query.list().filter(dato => typeof dato.codice === 'string' && dato.codice.toLowerCase().includes(currentValue)).map(el => el.codice);
    list.set(filteredList);
  }
  callBackFunctionAcquedotti = (list:any, currentValue:string) => {
    const filteredList = this.acquedottiService.query.list().filter(dato => typeof dato.codice === 'string' && dato.codice.toLowerCase().includes(currentValue)).map(el => el.codice);
    list.set(filteredList);
  }

  constructor(
    @Inject(IstatRegioniService) public regioniService: IstatRegioniService,
    @Inject(WaterSupplyZoneService) public wszService: WaterSupplyZoneService,
    @Inject(AcquedottiService) public acquedottiService: AcquedottiService,

  ) {}

  ngOnInit() {
    this.getWsz();
    this.getAcquedotti()
    this.form.addControl('istatRegione_equals', new FormControl<string | null>(null, []));
    this.form.addControl('istatComune_equals', new FormControl<string | null>(null, []));
    this.form.addControl('tipoPuntoCampionamento_equals', new FormControl<string | null>(null, []));
    this.form.addControl('idPuntoCampionamento_equals', new FormControl<string | null>(null, []));

    this.form.addControl('idAreraAto_equals', new FormControl<string | null>(null, [Validators.pattern(this.integerPattern)]));
    this.form.addControl('idAreraGestore_equals', new FormControl<string | null>(null, [Validators.pattern(this.integerPattern)]));

    this.form.addControl('codiceWsz_equals', new FormControl<string | null>(null, []));
    this.form.addControl('codiceAcquedotto_equals', new FormControl<string | null>(null, []));
    this.form.addControl('progressivoLineAcquedottistica_equals', new FormControl<string | null>(null, []));

    this.form.addControl('previsioneAbitantiServiti_greaterThanOrEqual', new FormControl<number | null>(null, []));
    this.form.addControl('previsioneAbitantiServiti_lessThanOrEqual', new FormControl<number | null>(null, []));

    this.form.addControl('previsionePortata_greaterThanOrEqual', new FormControl<number | null>(null, []));
    this.form.addControl('previsionePortata_lessThanOrEqual', new FormControl<number | null>(null, []));
    this.form.addControl('isDateValid_in', new FormControl<string | null>('', []));
    this.form.get('istatRegione_equals')?.valueChanges.subscribe(() => {
      this.filterComuni();
    });
    this.form.get('isDateValid_in')?.valueChanges.subscribe((value) => {

      if(!value && this.filtroDataValidita){
        this.resetIsDateValid(); 
      }
      
    });
  }

  getCheckbox() {

    this.checked = [];

    const allCheckboxes = this.checkBox.toArray();

    const checkedBoxes = allCheckboxes.filter((checkbox: any) => checkbox.checked);

    checkedBoxes.forEach((data: any) => {
      this.checked.push({
        checked: data.checked,
        value: data.value,
      });
    });

    const dati:string=this.checked.map(check=>check.value).join(",")
    this.form.get('isDateValid_in')?.setValue(dati);

  }

  filterComuni() {
    this.istatRegione.set(this.form.get('istatRegione_equals')?.value);
  }
  getWsz() {
    this.wszService.query.get({ pageable: { size: 99999 }}, ()=>{

     this.wszAll=this.wsz().map(el => el.codice)

    });
    
  }

  getAcquedotti() {
    this.acquedottiService.query.get({ pageable: { size: 99999 }}, ()=>{

     this.acquedottiAll=this.acquedotti().map(el => el.codice)

    });
  }
  resetCheckboxes() {
    this.checkBox.forEach((checkbox: any) => {
      checkbox.checked = false; 
    });
  }
  
  resetIsDateValid() {
    this.form.get('isDateValid_in')?.reset();  
    this.resetCheckboxes(); 
  }
  

}
